import React, {Component} from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ size: [] }],
      [{ color: [] }, { background: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      // ['link', 'image', 'video'],
      ['clean'],
    ],
};

class AboutUs extends Component {

  constructor(props) {
    super(props);
    this.state = {
        text: 'Initial text', // Initial string value
        input: '', // For user input
        id: 2,
        name: '',
        description: '',
        thumbnail: '',
        full_thumbnail_url: '',
        };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.appendToText = this.appendToText.bind(this);
  }

  handleInputChange(value) {
    this.setState({ input: value });
  }

  appendToText() {
    this.setState(prevState => ({
      text: prevState.text + ' ' + prevState.input, // Append user input to existing text
      input: '' // Clear input field after appending
    }));
  }

  // state = {
  //   id: 2,
  //   name: '',
  //   description: '',
  //   thumbnail: '',
  //   full_thumbnail_url: '',
  // }

  UNSAFE_componentWillMount() {
    this.getAbout();
  }

  getAbout = async () => {
    try {
      let results = await API.getAbout("about_us");
      let data = results.data;
      
      this.setState({ id : data.id, name: data.name, input: data[3].description });

    } catch (error) {
      console.log(error)
    }
  }

  onChangeFile = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file) return;
    let name = event.target.name;
    const formData = new FormData();
    formData.append("file", file);
    
    try {
      let results = await API.adminUpload(
        formData
      );
      
      if (results){
        this.setState(prevState => ({
          text: `<img src="${results.full_url}" alt="img"\>` + `${prevState.input}`, // Append user input to existing text
          input: `${prevState.input}<br />` + `<img src="${results.full_url}" alt="img"\>`
          // Clear input field after appending
        }));
        
        // this.state.thumbnail = results.filename;
        // this.state.full_thumbnail_url = results.full_url;
        // this.setState({});
        // this.setState({ data: {
        //   ...this.state.data,
        //   [name]: results.filename,
        // }})
      }

    } catch (error) {
      console.log(error)
    }
  }

  // handleChange = (value) => {
  //   console.log(value)
  //   this.setState({ description: value });
  // };

  handleSubmit = async (event) => {
    event.preventDefault();
    let data= {
      "name": "about_us",
      "description": this.state.input
        // "description": 'Update setting'
    }
    try {
      let results = await API.updateSetting(
        data
      );
      
      if (results.result === 1){
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
      }

    } catch (error) {
      console.log(error)
    }
  }

  render() {
    return (
        <div className="col-12">
            <ToastContainer />
            <form className="card" onSubmit={this.handleSubmit}>
              <h4 className="card-title"><strong>About Us</strong></h4>

              <div className="card-body row">
                 <div className="card col-12">
                  <div className="col-2">
                    <input type="file" id="des" hidden className="form-control" accept="image/*"
                      onChange={(e) => this.onChangeFile(e)}
                      />  
                      <button onClick={(e) => {
                      e.preventDefault()
                      document.getElementById("des").click()
                      }} type="buttom" className={`form-control btn-primary`} ><span style={{color: 'black'}}>Upload</span>
                      </button> 
                  </div>
                  
                    {/* <h4 className="card-title"><strong>Description</strong></h4> */} 
                    <div className="card-body" style={{marginTop: "-55px"}}>
                      <ReactQuill 
                        theme="snow" 
                        modules={modules}
                        style={{"height" : "600px"}} 
                        value={this.state.input} 
                        onChange={this.handleInputChange} />
                        <br /><br /><br /><br />
                    </div>
                </div>
              </div>

              <footer className="card-footer text-right" style={{paddingTop: 5}}>
                <button className="btn btn-secondary" type="reset">Cancel</button>
                <button className="btn btn-primary" type="submit">Submit</button>
              </footer>
            </form>
          </div>
    );
  }
}



export default AboutUs;

// AboutUs.modules = {
//   toolbar: {
//     container: "#toolbar",
//   }
// };
// AboutUs.formats = [
//   'header', 'font', 'size',
//   'bold', 'italic', 'underline', 'strike', 'blockquote',
//   'list', 'bullet', 'indent',
//   'link', 'image', 'video'
// ];
